import type { SvgIconComponent } from '@mui/icons-material';
import ArticleOutlined from '@mui/icons-material/ArticleOutlined';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import BugReportOutlined from '@mui/icons-material/BugReportOutlined';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import CampaignOutlined from '@mui/icons-material/CampaignOutlined';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import EventOutlined from '@mui/icons-material/EventOutlined';
import FitnessCenter from '@mui/icons-material/FitnessCenter';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import PaymentOutlined from '@mui/icons-material/PaymentOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import PersonOutline from '@mui/icons-material/PersonOutline';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SyncProblemOutlined from '@mui/icons-material/SyncProblemOutlined';
import TagOutlined from '@mui/icons-material/TagOutlined';

import { NotificationDisplayDomain } from '../redux/api/notificationsApi';

const DOMAIN_ICONS: Record<NotificationDisplayDomain, SvgIconComponent> = {
  [NotificationDisplayDomain.generic]: NotificationsOutlined,
  [NotificationDisplayDomain.user]: PersonOutline,
  [NotificationDisplayDomain.training]: FitnessCenter,
  [NotificationDisplayDomain.program]: AssignmentOutlined,
  [NotificationDisplayDomain.post]: ArticleOutlined,
  [NotificationDisplayDomain.comment]: ChatBubbleOutline,
  [NotificationDisplayDomain.subscription]: PeopleOutline,
  [NotificationDisplayDomain.relation]: PeopleOutline,
  [NotificationDisplayDomain.community]: GroupsOutlined,
  [NotificationDisplayDomain.exercise]: FitnessCenter,
  [NotificationDisplayDomain.file]: InsertDriveFileOutlined,
  [NotificationDisplayDomain.system]: SettingsOutlined,
  [NotificationDisplayDomain.maintenance]: BuildOutlined,
  [NotificationDisplayDomain.payment]: PaymentOutlined,
  [NotificationDisplayDomain.chat]: ForumOutlined,
  [NotificationDisplayDomain.marketing]: CampaignOutlined,
  [NotificationDisplayDomain.reminder]: EventOutlined,
  [NotificationDisplayDomain.calendar]: EventOutlined,
  [NotificationDisplayDomain.workout]: FitnessCenter,
  [NotificationDisplayDomain.hashtag]: TagOutlined,
  [NotificationDisplayDomain.sync]: SyncProblemOutlined,
  [NotificationDisplayDomain.bugReport]: BugReportOutlined,
  [NotificationDisplayDomain.notification]: NotificationsOutlined,
};

export function getNotificationDomainIcon(
  domain: NotificationDisplayDomain,
): SvgIconComponent {
  return DOMAIN_ICONS[domain] ?? NotificationsOutlined;
}
